import React from 'react';
import { useData } from '../context/DataContext';

const Factures = () => {
  const { factures } = useData();

  return (
    <div>
      <h2>📝 Factures</h2>
      <div className="cout-summary">
        <div className="cout-summary-item">
          <span>Total factures</span>
          <strong>{factures.length}</strong>
        </div>
      </div>
      <div className="table-scroll">
        <table className="data-table" role="table">
        <thead>
          <tr>
            <th>N° facture</th>
            <th>Date</th>
            <th>Client</th>
            <th>Chantier</th>
            <th>Montant HT</th>
            <th>TVA</th>
            <th>TTC</th>
            <th>Statut paiement</th>
          </tr>
        </thead>
        <tbody>
          {factures.map((f, i) => (
            <tr key={i}>
              <td>{f.numero}</td>
              <td>{f.date}</td>
              <td>{f.client}</td>
              <td>{f.chantier}</td>
              <td>{f.montantHT.toFixed(2)} €</td>
              <td>{f.tva.toFixed(2)} €</td>
              <td>{f.montantTTC.toFixed(2)} €</td>
              <td>
                <span className={`badge badge-${f.statut.toLowerCase().replace(' ', '-')}`}>
                  {f.statut}
                </span>
              </td>
            </tr>
          ))}
          {factures.length === 0 && (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center', color: 'var(--color-text-secondary)', padding: '2rem' }}>
                Aucune facture. Importez des données depuis l'onglet "Tableau de bord".
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Factures;